import React, { useState } from 'react';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EN_ACCEPT_LANGUAGE } from '../../../constants/acceptLanguageApi';
import { MerChantModel } from '../../../models/merChantModel';
import { TEXT_TITLE_COLOR } from '../../../constants/colors';

interface Props {
  branchValue: string[];
  onSelectBranch: (event: SelectChangeEvent<any>) => void;
  branchData: MerChantModel[];
  disabled: boolean;
  role?: string | undefined;
}

const SelectBranchComponent = ({
  branchValue,
  onSelectBranch,
  branchData,
  disabled,
  role,
}: Props) => {
  const { t, i18n } = useTranslation('global');
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleSelectAll = () => {
    if (selectAll) {
      onSelectBranch({ target: { value: [] } } as SelectChangeEvent<any>);
    } else {
      const allBranches = branchData.map((branch) =>
        i18n.language === EN_ACCEPT_LANGUAGE ? branch.nameEn : branch.nameLa
      );
      onSelectBranch({ target: { value: allBranches } } as SelectChangeEvent<any>);
    }
    setSelectAll(!selectAll);
  };

  const handleSelectedBranch = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;
    const isAllSelected = value.includes('selectAll');

    if (isAllSelected) {
      handleSelectAll();
    } else {
      setSelectAll(value.length === branchData.length);
      onSelectBranch(event);
    }
  };

  const isAllSelected = branchValue.length === branchData.length;

  return (
    <FormControl disabled={disabled} fullWidth size="small" margin="normal">
      <InputLabel id="Branch-label-id">{t('Branch')}</InputLabel>
      <Select
        labelId="Branch-label-id"
        id="Branch-id"
        label="Branch"
        multiple
        sx={{ borderRadius: '8px' }}
        value={branchValue}
        onChange={handleSelectedBranch}
        renderValue={(selected) => selected.join(', ')}
      >
        {/* Role Check for SUPER_ADMIN */}
        {role === 'SUPER_ADMIN' && (
          <MenuItem value="selectAll">
            <Checkbox
              checked={isAllSelected}
              indeterminate={branchValue.length > 0 && branchValue.length < branchData.length}
            />
            <ListItemText primary={t('coupon_page.Select All')} />
          </MenuItem>
        )}

        {branchData?.map((branch) => (
          <MenuItem
            key={branch.id}
            value={i18n.language === EN_ACCEPT_LANGUAGE ? branch.nameEn : branch.nameLa}
          >
            <Checkbox
              checked={branchValue.includes(
                i18n.language === EN_ACCEPT_LANGUAGE ? branch.nameEn : branch.nameLa
              )}
            />
            <ListItemText
              primary={
                <span>
                  <span style={{ color: TEXT_TITLE_COLOR }}>{branch?.company || 'Company'}</span>:{' '}
                  {i18n.language === EN_ACCEPT_LANGUAGE ? branch.nameEn : branch.nameLa}
                </span>
              }
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBranchComponent;
